import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchCommon, fetchDownloadBlobUrl} from '../../../../helpers/FetchUtils';
import {
    ACC_USER_AVATAR_VIEW
} from './constants';
import {
    accountUserAvatarViewSuccess,
    accountUserAvatarViewFail
} from './actions';
import {catchError} from "../../../../util/ErrorCatchUtils";
import {isNull} from "../../../../helpers/EmptyUtils";
import {layoutMainSignCheck} from "../../layouts/main/actions";

/**
 *
 */
function* accountUserAvatarView({payload: {userId, blobUrls}}) {
    try {
        const res1 = yield call(fetchCommon,
            '/api/account/user/avatar/user/' + userId,
            {method: "GET"});
        if (res1.success) {
            const downloadId = res1.data.downloadId;
            let res2 = yield call(fetchDownloadBlobUrl,
                '/api/storage/download/' + downloadId,
                {method: "GET"});
            if (res2.success) {
                let blobUrl = res2.blobUrl;
                if (isNull(blobUrls)) {
                    blobUrls = [];
                }
                let exists = false;
                for (let i in blobUrls) {
                    if (userId === blobUrls[i].userId) {
                        exists = true;
                        blobUrls.splice(i, 1, blobUrl);
                    }
                }
                if (exists === false) {
                    blobUrls.push({userId, blobUrl});
                }
                res2.blobUrls = blobUrls;
                yield put(accountUserAvatarViewSuccess(res2));
            } else {
                yield put(accountUserAvatarViewFail(res2));
            }
        } else {
            yield put(accountUserAvatarViewFail(res1));
        }
    } catch (error) {
        yield put(layoutMainSignCheck(catchError(error)));
        yield put(accountUserAvatarViewFail(catchError(error)));
    }
}

export function* accountUserAvatarViewWatcher() {
    yield  takeEvery(ACC_USER_AVATAR_VIEW, accountUserAvatarView);
}

function* AccountUserAvatarViewSaga() {
    yield all([
        fork(accountUserAvatarViewWatcher)]);
}

export default AccountUserAvatarViewSaga;
